export function getScrollY() {
    return window.pageYOffset;
}

export function getWidth() {
    return window.innerWidth;
}
